/**
 * Copyright 2020-present.
 * All rights reserved.
 * @author ductt24@ghtk.co
 * @description BaseSerive
 */
import axios from "axios";
import { forEach, get, has, isObject, join, size } from "lodash";

export default class BaseService {
  _baseurl;
  _endPoint;
  _client;
  _defaultHeaders;
  _defaultConfigs;
  constructor(baseUrl, endPoint) {
    this._baseurl = baseUrl;
    this._endPoint = endPoint;
    this._defaultHeaders = this.getDefaultHeaders();
    this._defaultConfigs = {
      baseURL: `${this._baseurl}/${this._endPoint}`,
      headers: this._defaultHeaders,
    };
    this._client = axios.create(this._defaultConfigs);
    this._client.interceptors.response.use(
      this.onResponseSuccess,
      this.onResponseError
    );
  }

  getDefaultHeaders() {
    let ghtkToken = localStorage.getItem("ghtk-token-storage");
    let headers = {};
    if (ghtkToken) {
      ghtkToken = JSON.parse(ghtkToken);
      let accessToken = get(ghtkToken, "accessToken.accessToken");
      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }
    }
    return headers;
  }

  /**
   * Xử lý khi nhận response
   * @param {*} response Response
   */
  onResponseSuccess(response) {
    let result = response.data || response;
    // if (has(result, "success") === false) {
    //   result.success = true;
    //   result = {
    //     success: true,
    //     data: result,
    //   };
    // }
    return result;
  }
  /**
   * Xử lý khi có lỗi
   * @param {*} error Error
   */
  onResponseError(error) {
    let status = get(error, "response.status");
    switch (status) {
      case 401:
        window.location.reload();
        break;
      default:
        break;
    }
    let message = get(error, "response.data.message");
    let data = get(error, "response.data.data");
    if (!message) {
      message = get(error, "response.data");
    }
    if (isObject(message) && size(message) > 0) {
      // Case message.non_field_errors
      let msgs = [];
      forEach(message, (msg) => {
        msgs = msgs.concat(msg);
      });
      message = join(msgs, ",");
    }
    return {
      success: false,
      message: message,
      data: data,
    };
  }

  getConfigs(configs) {
    if (size(this._defaultHeaders) == 0) {
      this._defaultHeaders = this.getDefaultHeaders();
      this._defaultConfigs.headers = this._defaultHeaders;
    }
    return {
      ...this._defaultConfigs,
      ...configs,
      headers: {
        ...this._defaultConfigs.headers,
        ...configs.headers,
      },
    };
  }

  async doGet(path, config) {
    return await this._client.get(path, config);
  }

  async doPost(path, data, config) {
    return await this._client.post(path, data, config);
  }
  async doPut(path, data, config) {
    return await this._client.put(path, data, config);
  }
  async doDelete(path, config) {
    return await this._client.delete(path, config);
  }
  doGetPromise(path, config) {
    return this._client.get(path, config);
  }
}
